import { I18nService } from "@perxis-auto/shared";
import { APP } from "../../../../config/app.js";
import "../../../../config/env.js";
import "../../../../config/events.js";
import "../../../../lib/store/createAppApi.js";
import "../../../../lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../lib/store/createAppSelector.js";
import "../../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../lib/store/hooks/useAppDispatch.js";
import "../../../../lib/store/hooks/useAppSelector.js";
import "../../../../lib/store/hooks/useAppStore.js";
import { BenefitDisclaimerEnum } from "../../../../types/benefits.js";
import { selectSlice } from "./selectSlice.js";
const selectBenefits = createAppSelector(selectSlice, (config) => {
  const { benefits } = config;
  const { i18n } = I18nService.getInstance();
  return {
    ...benefits,
    enable: (benefits == null ? void 0 : benefits.enable) ?? false,
    showAmount: (benefits == null ? void 0 : benefits.showAmount) ?? true,
    showOnlyBlock: (benefits == null ? void 0 : benefits.showOnlyBlock) ?? false,
    disclaimerDisplayType: (benefits == null ? void 0 : benefits.disclaimerDisplayType) ?? BenefitDisclaimerEnum.Paragraph,
    title: (benefits == null ? void 0 : benefits.title) ?? `${i18n.t("config.benefits.title", { ns: APP.name })}`,
    maxBenefit: (benefits == null ? void 0 : benefits.maxBenefit) ?? `${i18n.t("config.benefits.maxBenefit", { ns: APP.name })}`,
    priceWithBenefit: (benefits == null ? void 0 : benefits.priceWithBenefit) ?? `${i18n.t("config.benefits.priceWithBenefit", { ns: APP.name })}`,
    retailPrice: (benefits == null ? void 0 : benefits.retailPrice) ?? `${i18n.t("config.benefits.retailPrice", { ns: APP.name })}`,
    totalBenefit: (benefits == null ? void 0 : benefits.totalBenefit) ?? `${i18n.t("config.benefits.totalBenefit", { ns: APP.name })}`,
    tooltipTitle: (benefits == null ? void 0 : benefits.tooltipTitle) ?? `${i18n.t("config.benefits.tooltipTitle", { ns: APP.name })}`,
    tooltipBenefitColumn: (benefits == null ? void 0 : benefits.tooltipBenefitColumn) ?? `${i18n.t("config.benefits.tooltipBenefitColumn", { ns: APP.name })}`,
    tooltipDiscountColumn: (benefits == null ? void 0 : benefits.tooltipDiscountColumn) ?? `${i18n.t("format.withCurrency", {
      value: i18n.t("config.benefits.tooltipDiscountColumn", { ns: APP.name })
    })}`,
    tooltipPriceColumn: (benefits == null ? void 0 : benefits.tooltipPriceColumn) ?? `${i18n.t("format.withCurrency", {
      value: i18n.t("config.benefits.tooltipPriceColumn", { ns: APP.name })
    })}`,
    markersTooltipTitle: (benefits == null ? void 0 : benefits.markersTooltipTitle) ?? `${i18n.t("config.benefits.markersTooltipTitle", { ns: APP.name })}`
  };
});
export {
  selectBenefits
};
